<template>
  <div class="goods-control">
    <div class="add-goods-content" v-if="value.length">
      <draggable :list="value" animation="100">
        <div
          v-for="(item, i) of value"
          :key="item.id"
          :class="{ 'mr-0': (i + 1) % 4 === 0 }"
        >
          <img :src="item.imageUrl" alt="" />
          <i class="el-icon-error" @click="removeGoodItem(i)"></i>
        </div>
      </draggable>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
export default {
  components: {
    draggable
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    maxGoodsCount: {
      type: Number,
      default: 1
    }
  },
  methods: {
    removeGoodItem(i) {
      this.value.splice(i, 1);
      if (this.value.length === 0) {
        this.$emit("allRemoveDone");
      }
    }
  }
};
</script>

<style lang="less" scoped>
.goods-control {
  .add-goods-content {
    width: 332px;
    background: #f7f8fa;
    border-radius: 4px;
    padding: 14px 10px 0;
    > div {
      display: flex;
      flex-wrap: wrap;
      > div {
        width: 66px;
        height: 66px;
        position: relative;
        margin-right: 14px;
        margin-bottom: 14px;
        cursor: move;
        > img {
          width: 100%;
          height: 100%;
          border-radius: 3px;
        }
        > i {
          font-size: 16px;
          color: #bbbbbb;
          border-radius: 50%;
          background: #fff;
          position: absolute;
          top: -8px;
          right: -8px;
          cursor: pointer;
        }
      }
      > .mr-0 {
        margin-right: 0 !important;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/myviews/shoppMall/activityPageSet/fullPlatformSetQuery/lowCode/custom-component/marketingComponents/Seckill/components/GoodsControl.vue